(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const RECS_SECTION = 'cart-recommendations';
  const THRESHOLD = 5000;

  let cachedRecs = null;

  function initCarousel() {
    const track = document.querySelector('cart-drawer .mcd-recs__track');
    const dots = document.querySelector('cart-drawer .mcd-recs__dots');
    if (!track) return;

    // Elegir 8 al azar del pool y descartar el resto
    const SHOW = 8;
    const all = Array.from(track.querySelectorAll('.mcd-rec-card'));
    // barajar
    for (let i = all.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [all[i], all[j]] = [all[j], all[i]];
    }
    // reinsertar en orden barajado y quedarnos con los primeros SHOW
    all.forEach((card, i) => {
      if (i < SHOW) track.appendChild(card);
      else card.remove();
    });

    // Drag con ratón
    let down = false, startX, startScroll;
    track.addEventListener('mousedown', (e) => { down = true; track.classList.add('mcd-dragging'); startX = e.pageX; startScroll = track.scrollLeft; });
    window.addEventListener('mouseup', () => { down = false; track.classList.remove('mcd-dragging'); });
    track.addEventListener('mouseleave', () => { down = false; track.classList.remove('mcd-dragging'); });
    track.addEventListener('mousemove', (e) => { if (!down) return; e.preventDefault(); track.scrollLeft = startScroll - (e.pageX - startX); });

    // Puntos indicadores
    if (dots) {
      const cards = track.querySelectorAll('.mcd-rec-card');
      if (!cards.length) { dots.innerHTML = ''; return; }
      const cardW = cards[0].offsetWidth + 12;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const pages = Math.max(1, Math.ceil(maxScroll / cardW) + 1);
      dots.innerHTML = '';
      for (let i = 0; i < pages; i++) { const d = document.createElement('span'); d.className = 'mcd-dot'; dots.appendChild(d); }
      const dotEls = dots.querySelectorAll('.mcd-dot');
      const sync = () => {
        const sl = track.scrollLeft;
        let idx = (sl >= maxScroll - 2) ? pages - 1 : Math.round(sl / cardW);
        idx = Math.min(Math.max(idx, 0), pages - 1);
        dotEls.forEach((d, i) => d.classList.toggle('active', i === idx));
      };
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }

  // Rellena el carrusel si el mount está vacío
  async function ensureRecs() {
    const mount = document.querySelector('[data-mcd-recs]');
    if (!mount || mount.children.length > 0) return;
    if (cachedRecs) {
      mount.replaceChildren(cachedRecs.cloneNode(true));
      initCarousel();
      return;
    }
    try {
      const res = await fetch(`${window.Shopify.routes.root}?section_id=${RECS_SECTION}&t=${Date.now()}`);
      if (!res.ok) return;
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const recs = html.querySelector('.mcd-recs');
      if (recs) {
        cachedRecs = recs.cloneNode(true);
        const freshMount = document.querySelector('[data-mcd-recs]');
        if (freshMount) { freshMount.replaceChildren(recs); initCarousel(); }
      }
    } catch (e) {}
  }

  // Añadir desde recomendación
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-mcd-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    if (!id) return;
    btn.disabled = true;
    const items = document.querySelector('cart-drawer-items');
    const sections = items ? items.getSectionsToRender().map((s) => s.section).join(',') : '';
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mcd-recs', cartData: data });
      if (items) items.onCartUpdate();
    } catch (err) {} finally { btn.disabled = false; }
  });

  // Barra de envío: se actualiza en cada cambio
  function updateShipping(total) {
    const wrap = document.querySelector('cart-drawer .mcd-shipping');
    const fill = document.querySelector('cart-drawer .mcd-shipping__fill');
    const text = document.querySelector('cart-drawer .mcd-shipping__text');
    if (!wrap || !fill || !text || total == null) return;
    if (total >= THRESHOLD) {
      fill.style.width = '100%'; wrap.classList.add('mcd-shipping--done');
      text.innerHTML = '<strong>¡Envío Estándar GRATIS obtenido!</strong>';
    } else {
      fill.style.width = Math.max(2, Math.round((total / THRESHOLD) * 100)) + '%';
      wrap.classList.remove('mcd-shipping--done');
      const rem = ((THRESHOLD - total) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2 });
      text.innerHTML = 'Te faltan <strong>' + rem + ' €</strong> para el envío gratis';
    }
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.cartData && typeof e.cartData.total_price !== 'undefined') updateShipping(e.cartData.total_price);
      else fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json()).then(c => updateShipping(c.total_price));
    });
  }

  // Observer permanente: si Dawn vacía el mount al reinyectar, lo rellenamos (desde caché, sin rebarajar)
  const bodyObs = new MutationObserver(() => { ensureRecs(); });
  bodyObs.observe(drawer, { childList: true, subtree: true });

  // Al abrir el drawer: resetear caché para rebarajar y mostrar productos distintos
  const activeObs = new MutationObserver(() => {
    if (drawer.classList.contains('active')) {
      cachedRecs = null;
      const mount = document.querySelector('[data-mcd-recs]');
      if (mount) mount.replaceChildren();
      ensureRecs();
    }
  });
  activeObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });

  // Carga inicial
  document.addEventListener('DOMContentLoaded', ensureRecs);
})();